<template>
    <div class="text-center">

      <v-snackbar
        v-model="snackbar"
        :timeout="timeout"
          :color="rang"
          top
          right
      >
        {{ matn }}

        <template v-slot:action="{ attrs }">
          <v-btn
            color="#ffff"
            text
            v-bind="attrs"
            @click="snackbar = false"
          >
            Закрыть
          </v-btn>
        </template>
      </v-snackbar>
    </div>
  </template>

  <script>
    export default {
      props:{
          matn: {
              type: String,
              default: 'Ошибка'
          },
          rang:{
              type: String,
              default: '#D50000'
          }
          },

      data: () => ({
        snackbar: true,
        timeout: 2000,
      }),
    }
  </script>
